import React, { useState } from 'react';
import API from '../../services/api';
import Sheet from '../ui/Sheet';
import AvatarSelector from '../ui/AvatarSelector';

// View current avatar → choose another → save (PATCH /portal/avatar, the same endpoint onboarding uses). Avatars
// unlock with real Level; the server enforces it (a locked id is a 400 with an explanation), the selector shows it.
export default function AvatarPickerSheet({ currentAvatarId, name, onClose, onSaved }) {
  const [selected, setSelected] = useState(currentAvatarId || null);
  const [saving, setSaving] = useState(false);
  const [problem, setProblem] = useState('');

  const save = async () => {
    if (!selected || selected === currentAvatarId) { onClose(); return; }
    setSaving(true); setProblem('');
    try {
      const res = await API.patch('/portal/avatar', { avatar_id: selected });
      onSaved(res.data.avatar_id);
    } catch (err) {
      setProblem(err.response ? (err.response.data?.message || 'Could not save your avatar. Please try again.') : 'You appear to be offline. Try again when you\'re connected.');
    } finally { setSaving(false); }
  };

  return (
    <Sheet
      open
      onClose={onClose}
      title="Choose your avatar"
      size="lg"
      footer={(
        <>
          <button type="button" className="z-btn z-btn--secondary" onClick={onClose}>Cancel</button>
          <button type="button" className="z-btn z-btn--primary" disabled={saving || !selected} onClick={save}>{saving ? 'Saving…' : 'Save'}</button>
        </>
      )}
    >
      <AvatarSelector selectedId={selected} onSelect={setSelected} name={name} currentId={currentAvatarId} />
      {problem && <p className="z-error-text" role="alert" style={{ marginTop: 'var(--z-space-3)' }}>{problem}</p>}
    </Sheet>
  );
}
